<template>
  <div class="checkpoint_wrapper">
    <section class="body_header">
      <p class="header_title">Punto de Control</p>
    </section>
      <section class="body_datos">
      <b-field class="datos_item" :type="errors.has('formCP.nombre') ? 'is-danger': ''" :message="errors.has('formCP.nombre') ? errors.first('formCP.nombre') : ''">
        <b-input class="input-custom input-custom--high input-custom--nofocus" v-model="cp.name" placeholder="Nombre del Punto de Control" name="nombre" v-validate="'required'" @blur="goNext()" :disabled="!role"></b-input>
      </b-field>
      <b-field class="datos_item" v-if="$store.state.namespace=='experience'">
        <b-select 
          placeholder="Categoría"
          class="input-select-custom"
          v-model="cp.category"
          @input="setCategory($event)"
          >
          <option :value="cat.value" v-for="cat in expCat" :key="`select-cat-${cat.value}`">{{ cat.label }}</option>
        </b-select>
      </b-field>
      <b-field class="datos_item" v-if="hasTypification">
        <b-select 
          placeholder="Tipos"
          class="input-select-custom"
          v-model="typificationId"
          @input="setType($event)"
          >
          <option :value="type.id" v-for="type in checkpointTypes" :key="`select-type-${type.id}`">
            <div class="type_option">
              <div class="square" :style="{backgroundColor: type.color}"></div> <p>{{ type.name }}</p>
            </div>
          </option>
        </b-select>
      </b-field>
      <!-- <pre>{{ checkpointTypes }}</pre> -->
      <!-- <b-field class="datos_item" :type="errors.has('formCP.descripcion') ? 'is-danger': ''" :message="errors.has('formCP.descripcion') ? errors.first('formCP.descripcion') : ''">
        <b-input class="textarea-custom" placeholder="Descripcion" maxlength="200" type="textarea" name="descripcion" v-model="cp.description" v-validate="'required'" @blur="goNext()" :disabled="!role"></b-input>
      </b-field> -->
    </section>
  </div>
</template>

<script>
import imageUploader from "../Componentes/imageUploader";
import { mapGetters, mapState } from "vuex";
export default {
  name: "controlPointData",
  components: {
    imageUploader
  },
  props:["id"],
  data() {
    return {
      name: "",
      descripcion: "",
      creaCP: false,
      cp: {},
      name_bool: false,
      desc_bool: false,
      expCat: [{
        label: "Area común",
        value: "common-area"
      },{
        label: "Cliente",
        value: "client"
      }],
      category: undefined,
      typificationId: null
    };
  },
  async created() {
    if (this.id) {
      await this.$store.dispatch("GETCHECKPOINTTYPIFICATION", {
        id: this.company_id,
        namespace: this.namespace
      })
      await this.$store.dispatch("GETCHECKPOINT", {
        id_company: this.company_id,
        id_checkpoint: this.id
      });
      console.log(this.currentCP, this.cp);
      this.typificationId = this.cp.typification
    } else {
      await this.$store.dispatch("GETCHECKPOINTTYPIFICATION", {
        id: this.company_id,
        namespace: this.namespace
      })
    }
  },
  watch: {
    name_bool: function() {
      if (
        this.name_bool
      ) {
        this.creaCP = true;
        this.goNext();
      }
    }
    // desc_bool: function() {
    //   if (
    //     this.name_bool &&
    //     this.desc_bool
    //   ) {
    //     this.creaCP = true;
    //     this.goNext();
    //   }
    // }
  },
  computed: {
    ...mapGetters([
      "companyID",
      "company_id",
      "imageTemp",
      "newControlPoint",
      "currentCP",
      "imagePrew",
      "cp_id",
      "role"
    ]),
    ...mapState(['userId','namespace','checkpointTypes']),
    hasTypification(){
      if(!this.checkpointTypes) return false
      return this.checkpointTypes.length > 0
    }
  },
  watch: {
    currentCP: function(n) {
      //El currentCP puede ser uno ya creado o un objeto en vacio {} para una nueva creacion
      this.$set(this, "cp", this.currentCP);
      if (this.currentCP) {
        this.$store.commit("addImageTempPre", this.currentCP.imagefull);
        this.goNext();
      }
    },
    // "cp.category": function(n,o) {
    //   if(n !== o){
    //     this.$set(this, "cp", this.currentCP);
    //     this.goNext()
    //   }
    // }
  },
  methods: {
    goNext: function() {
      if (
        this.cp.name !== ""
      ) {
        if (this.$route.params.id) {
          var controlPoint = {
            name: this.cp.name,
            category: this.cp.category,
            typificationId: this.typificationId
          };
          this.$store.commit("changeCurrentCP", controlPoint);
        } else {
          this.creaCP = true;
          var controlPoint = {
            name: this.cp.name,
            flag: this.creaCP,
            author: this.userId,
            category: this.cp.category,
            typificationId: this.typificationId
          };
          console.log({controlPoint},{cp:this.cp, typificationId: this.typificationId});
          this.$store.commit("addNewControlPoint", controlPoint);
        }
      }
    },
    setCategory(value){
      this.$set(this.cp, "category", value);
      this.goNext()
    },
    setType(value){
      this.$set(this.cp, "typificationId", value);
      this.goNext()
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/styles/2.tools/mixins/_mediaquerys";
.checkpoint_wrapper {
  margin-bottom: 30px;
  @include media-xl(){
    padding: 0 200px 0 30px;
  }
  // max-width: 700px;
}
.body_datos {
  // width: 700px;
  .imageUploader {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .imageUploader_done {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .datos_item {
    margin-left: 25px 0;
    .input-high {
      input {
        height: 3.25em;
      }
    }
  }
  .datos_item:focus {
    .input-custom--nofocus {
      border: none;
    }
  }
}

.type_option {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
}
.square {
  height: 1.5rem;
  width: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/controlPointIn.vue